import {
  useOrderActions,
  BTN_STYLES,
  type ActionBtn,
} from "@/hooks/useOrderActions";
import type { OrderProductType } from "@/api/order";

interface ActionButtonsProps {
  productType: OrderProductType;
  mainStatus: string;
  mainStatusStep?: number;
  hasRefund?: number;
  refundStatus?: number;
  hasComment?: number;
  hasInvoice?: number;
  onAction: (action: string) => void;
  onNavigate: (p: string) => void;
  onReorder?: () => void;
}

export default function ProductActionButtons({
  productType,
  mainStatus,
  mainStatusStep = 99,
  hasRefund,
  refundStatus,
  hasComment,
  hasInvoice,
  onAction,
  onNavigate,
  onReorder,
}: ActionButtonsProps) {
  const { getBtns } = useOrderActions({
    productType,
    mainStatusStep,
    mainStatus,
    hasRefund,
    refundStatus,
    hasComment,
    hasInvoice,
  });

  const btns = getBtns();

  /** 点击处理 */
  const handleClick = (btn: ActionBtn) => {
    switch (btn.action) {
      case "pay":
        return onNavigate("/payment");
      case "review":
        return onAction("review");
      case "afterSale":
        return onAction("afterSale");
      case "cancel":
        return onAction("cancel");
      case "cancelRefund":
        return onAction("cancelRefund");
      case "invoice":
        return onAction("invoice");
      default:
        if (btn.type === "reorder") return onReorder?.();
    }
  };

  // 单个/两个按钮 → 横排；3-4个按钮 → 2列网格
  const isGrid = btns.length >= 3;

  return (
    <div
      className={`w-full ${isGrid ? "grid grid-cols-2 gap-3" : "flex justify-end gap-3"}`}
    >
      {btns.map((btn, i) => (
        <button
          key={i}
          onClick={() => handleClick(btn)}
          className={`flex items-center justify-center gap-1.5 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap transition-all active:scale-[0.97] ${
            isGrid ? "py-3 px-4" : "px-8 py-3"
          }`}
          style={{
            background: BTN_STYLES[btn.type].bg,
            color: BTN_STYLES[btn.type].color,
            border: "none",
          }}
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
}
